<div class="page-auth__contextual-messages"
    *ngIf="success || serverError">
    <div *ngIf="success"
        class="sl-status-bar sl-success"
        role="status">
        <mat-icon>check_circle</mat-icon> Your password was changed successfully!
    </div>

    <div *ngIf="serverError"
        class="sl-status-bar sl-error"
        role="status">
        <mat-icon>not_interested</mat-icon> >{{ serverError }}
    </div>
</div>

<form class="page-auth__form"
    [formGroup]="changePasswordFormGroup"
    #createNewPasswordForm="ngForm"
    (ngSubmit)="handleSubmitChangePassword()"
    *ngIf="!success">
    <ng-container *ngIf="userLoggedIn">
        <mat-form-field class="sl-form-field"
            [class.loading]="loading">
            <input matInput
                [formControlName]="'oldPassword'"
                type="password"
                placeholder="Old password*"
                autocapitalize="off">
            <mat-error *ngIf="changePasswordFormGroup.controls['oldPassword'].errors?.required">
                This input is required
            </mat-error>
            <mat-error *ngIf="changePasswordFormGroup.controls['oldPassword'].errors?.minlength">
                Password must be at least 8 characters.
            </mat-error>
        </mat-form-field>
    </ng-container>

    <mat-form-field class="sl-form-field"
        [class.loading]="loading">
        <input matInput
            [formControlName]="'password'"
            type="password"
            placeholder="New password*"
            autocapitalize="off">
        <mat-error *ngIf="changePasswordFormGroup.controls['password'].errors?.required">
            This input is required
        </mat-error>
        <mat-error *ngIf="changePasswordFormGroup.controls['password'].errors?.minlength">
            Password must be at least 8 characters.
        </mat-error>
    </mat-form-field>

    <mat-form-field class="sl-form-field"
        [class.loading]="loading">
        <input matInput
            [formControlName]="'confirmPassword'"
            type="password"
            placeholder="Confirm New password*"
            autocapitalize="off">
        <mat-error *ngIf="changePasswordFormGroup.controls['confirmPassword'].errors?.required">
            This input is required
        </mat-error>
        <mat-error *ngIf="changePasswordFormGroup.controls['confirmPassword'].errors?.minlength">
            Password must be at least 8 characters.
        </mat-error>
    </mat-form-field>

    <div class="page-auth__form__error-container"
        [class.loading]="loading">
        <ng-container *ngIf="changePasswordFormGroup.controls['confirmPassword'].errors && (changePasswordFormGroup.controls['confirmPassword'].dirty || changePasswordFormGroup.controls['confirmPassword'].touched)">
            <mat-error *ngIf="changePasswordFormGroup.controls['confirmPassword'].touched && !changePasswordFormGroup.controls['confirmPassword'].errors.validateEqual">Passwords don't match.</mat-error>
        </ng-container>
    </div>

    <div class="page-auth__form__submit-button-wrapper">
        <button [buttonType]="'primary'"
            type="submit"
            value="Submit"
            [disabled]="submitted && !createNewPasswordForm.form.valid">{{'Create New Password'}}</button>
    </div>

    <sl-loader [light]="true"
        *ngIf="loading"></sl-loader>
</form>